import {Toast} from 'vant';

// 节流函数, 注意这里的节流函数是无法使用 this 的
export const throttle = (func: Function, delay = 1000, showTip = false, immidiate = true) => {
  let previous = immidiate ? 0 : new Date().getTime(); // 初始化一个时间

  return function (...args: any[]): void {
    const now = new Date().getTime();
    if (now - previous >= delay) { // 如果本次触发和上次触发的时间间隔超过设定的时间
      func(...args); // 就执行事件处理函数 （eventHandler）
      previous = now; // 然后将本次的触发时间，作为下次触发事件的参考时间。
    }
    else if (showTip) {
      Toast('不要点击过快哦~');
    }
  };
};
